import React from "react";
import CloudStorage from "../../CloudStorage/CloudStorage";

export default function GetLocation({ type, city_name, country_title }) {
  return (
    <>
      {type == 3 ? (
        <div className="lang-sec">
          <h6>Location </h6>
          {country_title && <p> Country: {country_title}</p>}
          {city_name && <p> City: {city_name}</p>}
        </div>
      ) : (
        ""
      )}
    </>
  );
}
